export interface InventoryTransfer {
  comment?: string;
  from_warehouse_uuid?: string;
  movement_type: MovementType;
  supplies: InventoryTransferSupply[];
  to_warehouse_uuid?: string;
  urls?: string[];
}

interface InventoryTransferSupply {
  quantity: number;
  uuid: string;
}

export enum MovementTypeNames {
  "entry" = "Entrada",
  "exit" = "Salida",
  "sale" = "Venta",
  "sale_cancel" = "Cancelación",
  "product_change" = "Cambio de producto",
  "transfer" = "Transferencia",
  "adjustment_positive" = "Ajuste",
  "adjustment_negative" = "Ajuste",
  "waste" = "Merma",
  "event_restock" = "Resurtido (control de inventario)",
  "event_reset" = "Reset de inventario inicial",
  "event_correction" = "Corrección de inventario inicial (control)",
}

export type MovementType =
  | "entry"
  | "exit"
  | "sale"
  | "sale_cancel"
  // YOSHI-10261: pareja de movimientos que genera "Cambiar producto" (restaura el insumo original y descuenta el nuevo)
  | "product_change"
  | "transfer"
  | "adjustment_positive"
  | "adjustment_negative"
  | "waste"
  // YOSHI-10848: escritos por el control de inventario del evento; su quantity ya viene con signo
  // y nunca quedan pendientes de aprobación ni se crean desde "Mover insumos"
  | "event_restock"
  | "event_reset"
  | "event_correction";

export interface InventoryTransferResponse {
  data: {
    operation_code?: string;
    created_at?: string;
    requires_approval?: boolean;
  } | null;
  error_code: string;
  http_code: number;
  is_success: boolean;
  message: string;
  type: string;
}
